<template>
  <div>
    <form
      v-on:submit.prevent="onClick"
      class="login-form"
      v-bind:class="{ 'form--inverse': darkTheme }">
      <label-input
        :lowercase="true"
        ref="usernameInput"
        form-size="m"
        :label="$t('user.usernameLabel')"
        v-model="username"
        :type="'text'"
        :margin="false"
        :error="usernameErrorLenght || nameErrorUnique || invalidUsernameError"
        :errorMessage="displayNameErrorMessage">
      </label-input>

      <label-input
        :lowercase="true"
        ref="nameInput"
        form-size="m"
        :label="$t('user.nameLabel')"
        v-model="name"
        :type="'text'"
        :margin="false"
        :error="nameErrorLenght"
        :errorMessage="displayNameErrorMessage">
      </label-input>

      <label-input
        :lowercase="true"
        ref="surnameInput"
        form-size="m"
        :label="$t('user.surnameLabel')"
        v-model="surname"
        :type="'text'"
        :margin="false"
        :error="surnameErrorLenght"
        :errorMessage="displayNameErrorMessage">
      </label-input>

      <label-input
        ref="passwordInput"
        form-size="m"
        :label="$t('user.password')"
        v-model="password"
        :type="'password'"
        :margin="false"
        :error="passwordError"
        :errorMessage="displayPasswordErrorMessage"
        autocomplete="new-password">
      </label-input>

      <label-input
        ref="passwordRepeatInput"
        form-size="m"
        :label="$t('user.passwordRepeat')"
        v-model="passwordRepeat"
        :type="'password'"
        :margin="false"
        :error="passwordRepeatError"
        :errorMessage="$t('user.passwordShouldBeEqual')"
        autocomplete="new-password">
      </label-input>

      <label-input
        ref="Email"
        form-size="m"
        :label="$t('signin.email')"
        v-model="email"
        :margin="false"
        :error="emailError"
        :errorMessage="displayEmailErrorMessage">
      </label-input>

      <label-input
        v-show="showLicenseField"
        ref="licenseCode"
        form-size="m"
        :label="$t('health.signin.license')"
        v-model="license"
        :error="licenseError"
        :errorMessage="$t('health.signin.notValidLicense')">
      </label-input>

      <div>
        <p
          class="advice"
          v-html="$t('signin.advice')">
        </p>

        <grid-row>
          <grid-col col-size="3">
            <btn-pill
              class="btn-create"
              :btnText="$t('signin.btn')"
              v-on:click="onClick"
              btn-size="m">
            </btn-pill>
          </grid-col>
          <grid-col class="center-content" col-size="2">
            <div class="pointer red-text">
              <span @click='goToLogin()'>{{ $t('login.enter') }}</span>
          </div>
          </grid-col>
        </grid-row>
      </div>

    </form>
  </div>
</template>

<script>

import LabelInput from '@/components/shared/forms/LabelInput';
import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {mapActions} from 'vuex';
import variables from '../../stylesheets/_variables.scss';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import apiAuth from 'BRAND/api/auth';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  name: 'SigninForm',
  components: {
    LabelInput,
    BtnPill,
    FontAwesomeIcon,
    GridRow,
    GridCol
  },
  data () {
    return {
      username: '',
      name: '',
      surname: '',
      password: '',
      passwordRepeat: '',
      email: '',
      license: '',
      showLicenseField: false,
      /* Form field errors */
      nameErrorLenght: false,
      invalidUsernameError: false,
      usernameErrorLenght: false,
      surnameErrorLenght: false,
      nameErrorUnique: false,
      passwordError: false,
      passwordRepeatError: false,
      duplicatedEmail: false,
      emailError: false,
      licenseError: false,
      darkTheme: variables.theme === '"dark"'
    };
  },
  mounted () {
    const path = this.$route.query.path;
    this.showLicenseField = path == null || !path.includes('code=');
  },
  computed: {
    check () {
      return faCheck;
    },
    displayNameErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.nameErrorUnique) {
        errorMessage = this.$t('user.userAlreadyExists');
      } else if (this.invalidUsernameError) {
        errorMessage = this.$t('user.invalidUsername');
      }
      return errorMessage;
    },
    displayPasswordErrorMessage () {
      let errorMessage = this.$t('commons.mandatoryFieldMessage');
      if (this.passwordError) {
        errorMessage = this.$t('user.passwordFormatMessage');
      }
      return errorMessage;
    },
    displayEmailErrorMessage () {
      let errorMessage = this.$t('signin.notValidEmail');
      if (this.duplicatedEmail) {
        errorMessage = this.$t('signin.duplicatedEmail');
      }
      return errorMessage;
    }
  },
  methods: {
    ...mapActions([
      'login'
    ]),
    onClick () {
      this.clearErrors(this);

      if (this.isValidForm()) {
        const user = {};
        user.username = this.username.toLowerCase();
        user.name = this.name;
        user.surname = this.surname;
        user.password = this.password;
        user.email = this.email;
        user.license = this.license;

        apiAuth.healthSignin(this, user).then(() => {
          this.handlerSuccess();
        }, error => {
          this.handlerError(error);
        });
      }
    },
    handlerSuccess () {
      this.clearErrors();
      this.showSuccess = true;
      const credentials = {
        username: this.username.toLowerCase(),
        password: this.password
      };
      const path = this.$route.query.path ? this.$route.query.path : '/';
      this.login({
        context: this,
        credentials: credentials,
        path: path
      });
    },
    handlerError (error) {
      switch (error.status) {
        case 409:
          if (error.bodyText.toLowerCase().includes('username exists')) {
            this.nameErrorUnique = true;
          } else if (error.bodyText.toLowerCase().includes('already')) {
            this.duplicatedEmail = true;
            this.emailError = true;
          } else if (error.bodyText.toLowerCase().includes('invalid username')) {
            this.invalidUsernameError = true;
          }

          break;
        case 400:
          if (error.bodyText.includes('password')) {
            this.passwordError = true;
          } else if (error.bodyText.includes('license')) {
            this.licenseError = true;
          } else {
            this.emailError = true;
          }
          break;

        default:
          this.showError = true;
          break;
      }
    },
    isValidForm () {
      let valid = true;
      if (!(this.username && this.username.length > 0)) {
        valid = false;
        this.usernameErrorLenght = true;
      }
      if (!(this.name && this.name.length > 0)) {
        valid = false;
        this.nameErrorLenght = true;
      }
      if (!(this.surname && this.surname.length > 0)) {
        valid = false;
        this.surnameErrorLenght = true;
      }
      if (!(this.password && isValidPassword(this.password))) {
        valid = false;
        this.passwordError = true;
      }
      if (!(this.password === this.passwordRepeat)) {
        valid = false;
        this.passwordRepeatError = true;
      }
      if (!this.email && isValidEmail(this.email)) {
        valid = false;
        this.emailError = true;
      }

      return valid;
    },
    clearErrors () {
      this.nameErrorLenght = false;
      this.usernameErrorLenght = false;
      this.surnameErrorLenght = false;
      this.nameErrorUnique = false;
      this.passwordError = false;
      this.passwordRepeatError = false;
      this.emailError = false;
      this.licenseError = false;
      this.duplicatedEmail = false;
      this.invalidUsernameError = false;
    },
    goToLogin () {
      this.$emit('login');
    }
  }
};

const isValidPassword = (password) => {
  const containsLetters = /[a-z]*[A-Z]*/.test(password);
  const containsNumbers = /\d/.test(password);
  const passwordLength = password.length >= 6;
  return (containsLetters === true && containsNumbers === true && passwordLength === true);
};

const isValidEmail = (email) => {
  const regExp = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  return regExp.test(String(email).toLowerCase());
};

</script>

<style scoped lang="scss">
@import "src/stylesheets/variables";

span:hover {
  color: $primary;
  cursor: pointer;
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.red-text {
  color: $primary;
  font-weight: bold;
}

.login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;

  &:after {
    content: "";
    background-size: auto 100%;
    position: absolute;
    top: 13%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    opacity: 1;
    @media (min-width: $screen-l) {
      background: no-repeat left center url(~BRAND/assets/login-bg.jpg);
      z-index: -3;
      background-position: left top;
      background-size: auto;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    background-color: $login-background;
    @media (min-width: $screen-l) {
      background-color: transparent;
      background-image: radial-gradient(
          circle at 23% 35%,
          rgba($login-background, 0.5),
          rgba($login-background, 0.6),
          rgba($login-background, 0.9),
          $login-background 35%,
          $login-background
      );
    }
    @include brandCustom-loginBg();

    &:before {
      content: "";
      width: 100%;
      height: 100%;
      background-image: url($brandImage-LoginBgBefore);
      background-repeat: no-repeat;
      background-position: right bottom;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.4;
      z-index: 0;
      @include brandCustom-loginBgBefore();
    }
  }

  &__content {
    color: $login-text-color;
    @media (max-width: $screen-l-max) {
      padding: 0 $sp-margin-large;
    }
    @media (min-width: $screen-l) {
      display: flex;
    }
  }

  &__brand {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: $sp-margin-larger;
    @media (max-width: $screen-l-max) {
      margin-top: $sp-margin-large;
      flex-direction: row;
      max-width: ($sp * 80) + $sp-margin-larger;
      padding-right: 0;
      margin-bottom: $sp-margin;
    }
  }

  &__form {
    max-width: ($sp * 80) + $sp-margin-larger;
    @media (min-width: $screen-l) {
      padding-left: $sp-margin-larger;
      border-left: 1px solid $login-form-right-border;
    }

    form {
      margin-bottom: $sp-margin;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/auth/SigninForm.vue